import React, { createRef, useEffect, useState } from 'react';
import { useElementMetrics } from '../../../hooks/useElementMetrics';
import classNames from 'classnames';
import { Button } from '../buttons/Button';
import { TransitionGroup } from 'react-transition-group';
import { Fade } from '../animation/Fade';
import './expandableContainer.module.scss';

type Props = {
  collapsibleOffsetHeight: number;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  children: any;
};

export const ExpandableContainer = ({ collapsibleOffsetHeight, children }: Props) => {
  const [expanded, setExpanded] = useState(true);
  const [manuallyExpanded, setManuallyExpanded] = useState(false);
  const innerContainerRef = createRef<HTMLDivElement>();
  const metrics = useElementMetrics(innerContainerRef);
  const innerHeight = metrics ? metrics.offsetHeight : 0;
  useEffect(() => {
    if (innerHeight > collapsibleOffsetHeight && !manuallyExpanded) {
      setExpanded(false);
    }
  }, [innerHeight]);
  return (
    <div
      styleName={classNames('expandable-container')}
      style={{ maxHeight: expanded ? `${innerHeight}px` : `${collapsibleOffsetHeight}px` }}
    >
      <div ref={innerContainerRef}>{children}</div>
      <TransitionGroup>
        {!expanded && (
          <Fade>
            <div styleName="expand-button-wrapper">
              <Button
                type="normal"
                size="l"
                onClick={() => {
                  setExpanded(true);
                  setManuallyExpanded(true);
                }}
                styleName="expand-button"
                className="expand-button"
              >
                全部見る
              </Button>
            </div>
          </Fade>
        )}
      </TransitionGroup>
    </div>
  );
};
